import video1 from '../assets/videos/video1.mp4';
import video2 from '../assets/videos/video2.mp4';
import video3 from '../assets/videos/video3.mp4';
import video4 from '../assets/videos/video4.mp4';
import video5 from '../assets/videos/video5.mp4';


export const videoSources = [
   { id: 1, src: video1, title: 'City' },
   { id: 2, src: video2, title: 'VR girl' },
   { id: 3, src: video3, title: 'Nighttime' },
   { id: 4, src: video4, title: 'Big screens' },
   { id: 5, src: video5, title: 'Final Video' }
];